/**
 * Open a full HTML document in a new tab and invoke the browser print dialog.
 * Uses a blob URL so the tab is not stuck on about:blank (window.open +
 * noopener + document.write fails in modern Chromium).
 */
export function openHtmlForPrint(html: string): boolean {
  const htmlWithPrint = injectAutoPrint(html);
  const blob = new Blob([htmlWithPrint], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const printWindow = window.open(url, '_blank');
  if (!printWindow) {
    URL.revokeObjectURL(url);
    return false;
  }

  // Keep the blob alive long enough for print preview / dialog.
  window.setTimeout(() => URL.revokeObjectURL(url), 120_000);
  return true;
}

function injectAutoPrint(html: string): string {
  const script = `
<script>
  (function () {
    function run() {
      try { window.focus(); } catch (e) {}
      window.setTimeout(function () {
        try { window.print(); } catch (e) {}
      }, 200);
    }
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run);
  })();
</script>`;

  if (/<\/body>/i.test(html)) {
    return html.replace(/<\/body>/i, `${script}</body>`);
  }
  return `${html}${script}`;
}
